import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "undo-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8.525 5.52a.75.75 0 0 0-1.06-1.06l-3 3a.748.748 0 0 0 0 1.06l3 3a.75.75 0 1 0 1.06-1.06l-1.72-1.72h7.19c2.963 0 5.25 2.187 5.25 4.75 0 2.564-2.287 4.75-5.25 4.75h-8a.75.75 0 0 0 0 1.5h8c3.666 0 6.75-2.737 6.75-6.25 0-3.512-3.084-6.25-6.75-6.25h-7.19l1.72-1.72Z" }, null, -1)
  ])))
}
export default { render: render }